import { LanguagesEnum } from '../../config/languages';

const Configuration = {
  // backgroundImage: require('../../assets/images/backgrounds/background_login_register.png'),
  backgroundImage: require('../../assets/images/backgrounds/dark-material-bg.jpg'),
  registerIcon: require('../../assets/images/logos/logo-oss-portal.png'),
};

export default Configuration;

export enum EnumSchemeTypes {
  eu = 'EU',
  non_eu = 'NON_EU',
  ioss = 'IOSS',
}

export const Translations = {
  signup_title: {
    [LanguagesEnum.English]: 'Create an One Stop Shop Account',
    [LanguagesEnum.Greek]: 'Δημιουργήστε έναν One Stop Shop λογαριασμό',
  },
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  form_field_username: {
    [LanguagesEnum.English]: 'Username',
    [LanguagesEnum.Greek]: 'Username',
  },
  form_field_password: {
    [LanguagesEnum.English]: 'Password',
    [LanguagesEnum.Greek]: 'Κωδικός',
  },
  form_button_register: {
    [LanguagesEnum.English]: 'Create OSS Account',
    [LanguagesEnum.Greek]: 'Δημιουργία OSS Λογαριασμού',
  },
  label_forgot_password: {
    [LanguagesEnum.English]: 'Forgot Password',
    [LanguagesEnum.Greek]: 'Ξεχάσατε κωδικό;',
  },
  back_to_login: {
    [LanguagesEnum.English]: 'Back to login',
    [LanguagesEnum.Greek]: 'Επιστροφή στο Login',
  },
  already_have_an_account: {
    [LanguagesEnum.English]: 'Already have an account?',
    [LanguagesEnum.Greek]: 'Εχετε ήδη λογαριασμό;',
  },
};
